import { lexer, walkTokens, type Token, type Tokens } from 'marked';
import { allocateHeadingAnchorId } from './headingAnchorId';

export interface MarkdownTocEntry {
    depth: number;
    id: string;
    title: string;
}

/**
 * Headings in document order with ids matching the skill panel markdown HTML renderer
 * (GitHub-style slugs + duplicate suffixes).
 */
export function extractMarkdownTableOfContents(markdown: string): MarkdownTocEntry[] {
    const tokens = lexer(markdown);
    const idCounts = new Map<string, number>();
    const entries: MarkdownTocEntry[] = [];
    walkTokens(tokens, (token: Token) => {
        if (token.type === 'heading') {
            const heading = token as Tokens.Heading;
            const id = allocateHeadingAnchorId(heading.text, idCounts);
            entries.push({ depth: heading.depth, id, title: heading.text.trim() });
        }
    });
    return entries;
}
